import React from "react";
import Rutas from "./rutas/Rutas";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";

const App = () => {
  return (
    <div className="">
      <Rutas />
    </div>
  );
};

export default App;
